import { Pipe, PipeTransform } from '@angular/core'
import { type BinaryOrBase64 } from '@lg/shared'
import { toBase64 } from '@lg/shared/bridges/data'

@Pipe({
	name: 'base64',
	standalone: false,
})
export class Base64Pipe implements PipeTransform {
	transform(data: BinaryOrBase64): string {
		return toBase64(data)
	}
}
